module.exports = __webpack_public_path__ + "static/SharpGrotesk-Medium-2041064823cc5588beef4a9f6852ceb6.otf";